import React from "react";

import { ToggleArrowIcon } from "@common/assets/toggleArrowIcon";
import { SelectList } from "@common/selectList";
import { Props } from "./types";
import styles from "./styles.scss";
import classNames from "classnames";

const protocols = [
  { name: "3.0", value: "CAS30" },
  { name: "2.0", value: "CAS20" },
  { name: "1.0", value: "CAS10" },
];

function ProtocolSelect({ protocol, select }: Props) {
  const selectedProtocol = protocols.find(({ value }) => value === protocol);

  return (
    <SelectList
      rootClassName={styles.protocolSelect}
      listClassName={styles.listRoot}
    >
      {({ isOpen, select: s }) => ({
        input: (
          <div className={classNames(styles.input, { [styles.open]: isOpen })}>
            <p className={styles.name}>
              {selectedProtocol ? selectedProtocol.name : protocols[0].name}
            </p>
            <div className={styles.iconBox}>
              <ToggleArrowIcon className={styles.icon} />
            </div>
          </div>
        ),
        list: (
          <div className={styles.list}>
            {protocols.map((protocol) => (
              <div
                key={protocol.value}
                className={styles.item}
                onClick={() => s(select(protocol.value))}
              >
                {protocol.name}
              </div>
            ))}
          </div>
        ),
      })}
    </SelectList>
  );
}

export { ProtocolSelect };
